type SectionHeadingProps = {
  eyebrow: string;
  title: string;
  desc?: string;
  align?: "left" | "center";
};

export default function SectionHeading({
  eyebrow,
  title,
  desc,
  align = "left",
}: SectionHeadingProps) {
  const isCenter = align === "center";
  return (
    <div className={isCenter ? "flex flex-col items-center text-center" : "flex flex-col"}>
      <span className="inline-flex items-center gap-2 rounded-full bg-accent-100 px-3 py-1 text-xs font-medium tracking-wide text-accent-900">
        <i className="ri-sparkling-2-line" />
        {eyebrow}
      </span>
      <h2 className="mt-3 font-heading text-3xl md:text-4xl text-foreground-950 tracking-wide">
        {title}
      </h2>
      {desc && (
        <p
          className={`mt-3 max-w-3xl text-sm md:text-base leading-relaxed text-foreground-600 ${
            isCenter ? "" : "md:max-w-2xl"
          }`}
        >
          {desc}
        </p>
      )}
    </div>
  );
}